import {
  FETCHING_USERS_REQUEST,
  FETCHING_USERS_SUCCEDDED,
  FETCHING_USERS_FAILED,
  INVALIDATE_USERS,
  FETCHING_INVITATIONS_REQUEST,
  FETCHING_INVITATIONS_SUCCEDDED,
  FETCHING_INVITATIONS_FAILED,
  INVITE_USER_REQUEST,
  INIVITE_USER_SUCCEDDED,
  INIVITE_USER_FAILED,
  INVALIDATE_ERROR_MESSAGE,
  SELECT_USER,
  INVALIDATE_USER,
  UPDATE_USER_ACTIVATION,
  UPDATE_USER_ACTIVATION_SUCCEDDED,
  UPDATE_USER_ACTIVATION_FAILED,
  UPDATE_USER_ACCESS,
  UPDATE_USER_ACCESS_SUCCEEDED,
  UPDATE_USER_ACCESS_FAILED,
  RESEND_USER_INVITATION,
  RESEND_USER_INVITATION_SUCCEDDED,
  RESEND_USER_INVITATION_FAILED,
  DELETE_USER_INVITATION,
  DELETE_USER_INVITATION_SUCCEDDED,
  DELETE_USER_INVITATION_FAILED,
  ASSIGN_USER_ROLE,
  ASSIGN_USER_ROLE_SUCCEEDED,
  ASSIGN_USER_ROLE_FAILED,
  FETCHING_USER_MANAGEMENT_LIST_REQUEST,
  FETCHING_USER_MANAGEMENT_LIST_SUCCEEDED,
  FETCHING_USER_MANAGEMENT_LIST_FAILED,
  INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_REQUEST,
  INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_SUCCEDDED,
  INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_FAILED,
  FETCHING_USER_MANAGEMENT_USER_REQUEST,
  FETCHING_USER_MANAGEMENT_USER_SUCCEEDED,
  FETCHING_USER_MANAGEMENT_USER_FAILED,
  FETCHING_USER_GROUPS_FOR_USER_REQUEST,
  FETCHING_USER_GROUPS_FOR_USER_SUCCEEDED,
  FETCHING_USER_GROUPS_FOR_USER_FAILED,
  INVALIDATE_USER_GROUPS,
  UPDATE_USER_ROLES,
  UPDATE_USER_ROLES_SUCCEEDED,
  UPDATE_USER_ROLES_FAILED,
} from "./actionTypes.jsx";
import axios from "axios";
import buildUrl from "build-url-ts";
import _ from "lodash";

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const usersApiUrl = `${process.env.REACT_APP_USERS_API_URL}`;
const USER_BASE_URL = `${apiUrl}/api/2.0/users`;
const V3_USERS_URL = `${usersApiUrl}/users/3.0`;
// const INVITATION_URL = `${apiUrl}/api/2.0/invitations`;
const INVITATION_URL = `${usersApiUrl}/users/3.0/invitations`;

/*
 * FETCH USERMANAGEMENT LIST
 */
export function fetchUserManagementList(page, query, filterType) {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_USER_MANAGEMENT_LIST_REQUEST));

    let param = {
      query: query,
      page: page,
    };

    return axios({
      method: "GET",
      url: `${USER_BASE_URL}/user_management/${filterType}`,
      params: param,
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(
            FETCHING_USER_MANAGEMENT_LIST_SUCCEEDED,
            response.data,
          ),
        ),
      )
      .catch((error) =>
        dispatch(
          fetchingFailedAction(FETCHING_USER_MANAGEMENT_LIST_FAILED, error),
        ),
      );
  };
}

/*
 * FETCH USERMANAGEMENT USER
 */
export function fetchUserManagementUser(userId) {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_USER_MANAGEMENT_USER_REQUEST));

    return axios({
      method: "GET",
      url: `${USER_BASE_URL}/user_management/user/${userId}`,
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(
            FETCHING_USER_MANAGEMENT_USER_SUCCEEDED,
            response.data,
          ),
        ),
      )
      .catch((error) =>
        dispatch(
          fetchingFailedAction(FETCHING_USER_MANAGEMENT_USER_FAILED, error),
        ),
      );
  };
}

/*
 * FETCH ACCOUNT USERS
 */
export function fetchAccountUsers(page, query) {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_USERS_REQUEST));

    let param = {
      query: query,
      page: page,
    };

    return axios({
      method: "GET",
      url: `${USER_BASE_URL}/all`,
      params: param,
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(FETCHING_USERS_SUCCEDDED, response.data),
        ),
      )
      .catch((error) =>
        dispatch(fetchingFailedAction(FETCHING_USERS_FAILED, error)),
      );
  };
}

export function invalidateAccountUsers() {
  return {
    type: INVALIDATE_USERS,
    payload: {},
  };
}

export function shouldFetchUsers(state) {
  return shouldFetchResource(state.settings.userManagement.items);
}

/*
 * FETCH ACCOUNT INVITATIONS
 */
export function fetchAccountInvitations(page, query) {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_INVITATIONS_REQUEST));

    let param = {
      query: query,
      page: page,
      limit: 30,
    };

    return axios({
      method: "GET",
      url: `${INVITATION_URL}/search`,
      data: param,
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(
            FETCHING_INVITATIONS_SUCCEDDED,
            response.data,
          ),
        ),
      )
      .catch((error) =>
        dispatch(fetchingFailedAction(FETCHING_INVITATIONS_FAILED, error)),
      );
  };
}

/*
 *  INVITE USER
 */
export function inviteUser(user) {
  return function (dispatch) {
    dispatch(fetchingAction(INVITE_USER_REQUEST));

    return axios({
      method: "POST",
      url: INVITATION_URL,
      data: user,
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(INIVITE_USER_SUCCEDDED, response.data),
        ),
      )
      .catch((error) =>
        dispatch(fetchingFailedAction(INIVITE_USER_FAILED, error.errors)),
      );
  };
}

export function invalidateErrorMessage() {
  return {
    type: INVALIDATE_ERROR_MESSAGE,
    payload: {},
  };
}

/*
 * SELECT USER
 */
export function selectUser(user) {
  return {
    type: SELECT_USER,
    payload: user,
  };
}

export function invalidateUser() {
  return {
    type: INVALIDATE_USER,
    payload: {},
  };
}

/*
 * UPDATE USER ACTIVATION
 */
export function updateUserActivation(user) {
  return function (dispatch) {
    const { id, ...rest } = user;
    dispatch(fetchingAction(UPDATE_USER_ACTIVATION));

    return axios({
      method: "PUT",
      url: `${V3_USERS_URL}/${id}/permissions`,
      data: rest,
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(
            UPDATE_USER_ACTIVATION_SUCCEDDED,
            response.data,
          ),
        ),
      )
      .catch((error) =>
        dispatch(fetchingFailedAction(UPDATE_USER_ACTIVATION_FAILED, error)),
      );
  };
}

/*
 * ASSIGN USER ROLE
 */
export function assignUserRole(user) {
  return function (dispatch) {
    dispatch(fetchingAction(UPDATE_USER_ROLES));
    const roles = _.get(user, "roles", []);
    let roleIds = roles?.map((role) => _.get(role, "id"));
    roleIds = _.filter(roleIds, (roleId) => roleId?.length > 0);

    return axios({
      method: "PUT",
      url: `${usersApiUrl}/users/3.0/${user.id}/role`,
      data: {
        roles: roleIds,
      },
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(UPDATE_USER_ROLES_SUCCEEDED, response.data),
        ),
      )
      .catch((error) =>
        dispatch(fetchingFailedAction(UPDATE_USER_ROLES_FAILED, error)),
      );
  };
}

/*
 * UPDATE USER ACCESS
 */
export function updateUserAccess(user) {
  return function (dispatch) {
    const { id, ...rest } = user;
    dispatch(fetchingAction(UPDATE_USER_ACCESS));

    return axios({
      method: "PUT",
      url: `${V3_USERS_URL}/${id}/permissions`,
      data: rest,
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(UPDATE_USER_ACCESS_SUCCEEDED, response.data),
        ),
      )
      .catch((error) =>
        dispatch(fetchingFailedAction(UPDATE_USER_ACCESS_FAILED, error)),
      );
  };
}

/*
 * RESEND INVITATION
 */
export function resendInvitation(id) {
  return function (dispatch) {
    dispatch(resendingInvitation(id));

    return axios({
      method: "POST",
      url: `${INVITATION_URL}/${id}/resend`,
    })
      .then((response) => dispatch(resendingInvitationSuccedded(id)))
      .catch((errors) =>
        dispatch(resendingInvitationFailed(id, errors)),
      );
  };
}

function resendingInvitation(id) {
  return {
    type: RESEND_USER_INVITATION,
    payload: id,
  };
}

function resendingInvitationSuccedded(id) {
  return {
    type: RESEND_USER_INVITATION_SUCCEDDED,
    payload: id,
  };
}

function resendingInvitationFailed(id, errors) {
  return {
    type: RESEND_USER_INVITATION_FAILED,
    payload: {
      id: id,
      errors: errors,
    },
  };
}

/*
 * DELETE INVITATION
 */
export function deleteInvitation(id) {
  return function (dispatch) {
    dispatch(deletingInvitation(id));

    return axios({
      method: "DELETE",
      url: `${INVITATION_URL}/${id}`,
    })
      .then((response) => dispatch(deletingInvitationSuccedded(id)))
      .catch((error) =>
        dispatch(deletingInvitationFailed(id, error.response.data)),
      );
  };
}

function deletingInvitation(id) {
  return {
    type: DELETE_USER_INVITATION,
    payload: id,
  };
}

function deletingInvitationSuccedded(id) {
  return {
    type: DELETE_USER_INVITATION_SUCCEDDED,
    payload: id,
  };
}

function deletingInvitationFailed(id, error) {
  return {
    type: DELETE_USER_INVITATION_FAILED,
    payload: {
      id: id,
      error: error,
    },
  };
}

/**
 * Intialting download request for report
 */
export function intializeDownloadReport(id, request, page, limit) {
  return function (dispatch) {
    dispatch(initializingDownloadReport());

    let url = buildUrl(USER_BASE_URL, {
      path: `/download/${id}/data`,
    });

    let params = {
      page,
      limit,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
    })
      .then((response) =>
        dispatch(initializingDownloadReportSuccedded(response.data)),
      )
      .catch((error) => {
        console.log(error);
        return dispatch(initializingDownloadReportFailed(error));
      });
  };
}

function initializingDownloadReport() {
  return {
    type: INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_REQUEST,
    payload: {},
  };
}

function initializingDownloadReportSuccedded(json) {
  return {
    type: INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_SUCCEDDED,
    payload: json,
  };
}

function initializingDownloadReportFailed(error) {
  return {
    type: INTIALIZING_USER_MANAGEMENT_DOWNLOAD_REPORT_FAILED,
    payload: error,
  };
}

/*
 * FETCH USER_GROUPS FOR USER
 */
export function fetchUserGroupsForUser(page, userId) {
  return function (dispatch) {
    dispatch(fetchingAction(FETCHING_USER_GROUPS_FOR_USER_REQUEST));

    let param = {
      page: page,
    };

    return axios({
      method: "GET",
      url: `${USER_BASE_URL}/user_management/user_groups/user/${userId}`,
      params: param,
    })
      .then((response) =>
        dispatch(
          fetchingSucceededAction(
            FETCHING_USER_GROUPS_FOR_USER_SUCCEEDED,
            response.data,
          ),
        ),
      )
      .catch((error) =>
        dispatch(
          fetchingFailedAction(FETCHING_USER_GROUPS_FOR_USER_FAILED, error),
        ),
      );
  };
}

export function invalidateUserGroups() {
  return {
    type: INVALIDATE_USER_GROUPS,
    payload: {},
  };
}

/*
 * Common functions
 */
function fetchingAction(type) {
  return {
    type: type,
    payload: {},
  };
}

function fetchingSucceededAction(type, json) {
  return {
    type: type,
    payload: json,
  };
}

function fetchingFailedAction(type, error) {
  return {
    type: type,
    payload: error,
  };
}

export function shouldFetchResource(resource) {
  if (!resource) {
    return true;
  } else if (resource.loading) {
    return false;
  } else {
    return resource.invalidated;
  }
}
